import {
  agent_force,
  cpq,
  data_cloud,
  DMS,
  heroku,
  non_profit,
} from "../../helpers/constant/imageUrl";

export const PRODUCTS = [
  {
    img: agent_force,
    text: "Salesforce Agent Force",
    path: "/products/salesforce-agent-force",
  },
  {
    img: "/images/crm.webp",
    text: "Sales Cloud",
    path: "/products/sales-cloud",
  },
  {
    img: "/images/heart.webp",
    text: "Service Cloud",
    path: "/products/service-cloud",
  },
  {
    img: "/images/loc.webp",
    text: "Field Service Lightning",
    path: "/products/field-service-lightning",
  },
  {
    img: DMS,
    text: "DMS & Mobile App",
    path: "/products/dms-mobile-app",
  },
  {
    img: "/images/search.webp",
    text: "Marketing Cloud",
    path: "/products/marketingcloud",
  },
  {
    img: "/images/exp.webp",
    text: "Commerce Cloud",
    path: "/products/commerce-cloud",
  },
  {
    img: cpq,
    text: "CPQ",
    path: "/products/cpq",
  },
  {
    img: data_cloud,
    text: "Data Cloud",
    path: "/products/data-cloud",
  },
  {
    img: non_profit,
    text: "Non Profit",
    path: "/products/nonprofit",
  },
  {
    img: "/images/crmanalyticslogo.svg",
    text: "CRM Analytics",
    path: "/products/crmanalytics",
  },

  {
    img: heroku,
    text: "Heroku",

    path: "/products/heroku",
  },
];

export const DIRECT_CARDS = [
  {
    img: "/images/scard1.webp",
    alt: "Agent Force customer service",
    title: "Revolutionize Customer Service with Salesforce Agent Force",
    path: "/products/salesforce-agent-force",
  },
  {
    img: "/images/scard2.webp",
    alt: "Sales automation deals",
    title: "Close Deals Faster with Intelligent Sales Automation",
    path: "/products/sales-cloud",
  },
  {
    img: "/images/scard3.webp",
    alt: "Service Cloud customers",
    title: "Happy Customers, Happier Teams – Powered by Service Cloud",
    path: "/products/service-cloud",
  },
  {
    img: "/images/scard4.webp",
    alt: "Field service workforce",
    title: "Empower Your Mobile Workforce with Intelligent Field Service Management",
    path: "/products/field-service-lightning",
  },
  {
    img: "/images/scard5.webp",
    alt: "DMS distribution network",
    title: "Optimize Your Distribution Network with Salesforce DMS",
    path: "/products/dms-mobile-app",
  },
  {
    img: "/images/scard6.webp",
    alt: "Marketing Cloud engagement",
    title: "Elevate Your Customer Engagement with Salesforce Marketing Cloud",
    path: "/products/marketingcloud",
  },
  {
    img: "/images/scard7.webp",
    alt: "CPQ sales process",
    title: "Streamline Your Sales Process with Salesforce CPQ",
    path: "/products/commerce-cloud",
  },
  {
    img: "/images/scard8.webp",
    alt: "Data Cloud analytics",
    title: "Unlock the Power of Your Data with Salesforce Data Cloud",
    path: "/products/data-cloud",
  },
];
